import { createReducer } from "@reduxjs/toolkit";
import type { RetrievalState } from "@redux/state/shared-types";
import { retrievePublicStudios } from "./retrieve-public-studios";
import type { PublicStudioListVM } from "@shared-kernel/application/ports/public/public-repository";

const initialState: RetrievalState<PublicStudioListVM[]> = { fetching: "idle", data: [] };

export const retrievePublicStudiosReducer = createReducer<RetrievalState<PublicStudioListVM[]>>(initialState, builder => {
  builder.addCase(retrievePublicStudios.fulfilled, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetching: "success",
    };
  });
  builder.addCase(retrievePublicStudios.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(retrievePublicStudios.rejected, state => {
    return {
      ...state,
      fetching: "failed",
    };
  });
});
